import { useUserContext } from '@/app/context/UserContext';
import { useCompanyContext } from '@/app/context/CompanyContext';
import { useColorMode, useConfirmDialog } from '@/hooks';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider, Avatar, Chip, Switch } from '@mui/material';
import { useParams, useRouter } from 'next/navigation';
import { TbArrowsLeftRight, TbLogout, TbMoon, TbUser } from 'react-icons/tb';
import clsx from 'clsx';
import { useMemo } from 'react';
export const AppLayoutUserMenu = ({
  anchorEl,
  open,
  onClose
}) => {
  const {
    confirm
  } = useConfirmDialog();
  const {
    clearUser,
    user
  } = useUserContext();
  const {
    company,
    companyConfig
  } = useCompanyContext();
  const {
    companySlug
  } = useParams();
  const router = useRouter();
  const {
    colorMode,
    setColorMode
  } = useColorMode();
  const isDarkModeEnabled = companyConfig?.isDarkModeEnabled === true;
  const companyLogoUrl = useMemo(() => {
    if (companyConfig?.showCompanyLogo) {
      if (companyConfig?.companyLogoUrl) {
        return companyConfig.companyLogoUrl;
      }
      return companySlug ? `/images/logo/${companySlug}.png` : '';
    }
    return '';
  }, [companyConfig, companySlug]);
  const handleConfirmLogout = async e => {
    e?.preventDefault();
    try {
      clearUser();

      // Small delay to ensure state updates are processed
      setTimeout(() => {
        window.location.replace('/auth/logout?returnTo=' + new URL('/api/auth/logout-callback', window.location.origin).toString());
      }, 100);
    } catch (error) {
      console.error('Logout error', error);
    }
  };
  const handleLogout = async () => {
    confirm({
      title: 'Sign Out',
      content: 'Are you sure you want to sign out?',
      color: 'error',
      onConfirm: () => handleConfirmLogout()
    });
  };
  const handleToggleColorMode = () => {
    setColorMode(colorMode === 'dark' ? 'light' : 'dark');
  };
  return <Menu id="user-menu" anchorEl={anchorEl} open={open} onClose={onClose} anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right'
  }} transformOrigin={{
    vertical: 'top',
    horizontal: 'left'
  }} slotProps={{
    paper: {
      className: 'w-72! max-w-80! rounded-xl! border border-[var(--border)]! shadow-lg! ml-2!'
    }
  }} MenuListProps={{
    className: 'py-0!'
  }}>
            <div className="flex flex-col items-center px-4 pt-6 text-center">
                <Avatar src={user?.picture || ''} alt={user?.name || 'John Doe'} className="size-16! shrink-0!" />
                <div className="mt-3 flex w-full min-w-0 flex-col items-center">
                    <p className="w-full truncate text-base font-semibold text-foreground">{user?.name || 'John Doe'}</p>
                    <p className="w-full truncate text-sm text-foreground-muted">{user?.email || 'john.doe@example.com'}</p>
                </div>
            </div>
            {company?.companyName && <div className="py-3 px-4 flex items-center justify-center gap-2">
                    <Chip avatar={companyLogoUrl ? <Avatar src={companyLogoUrl} alt={company.companyName || ''} className="size-4! border! border-border!" slotProps={{
        img: {
          className: 'object-contain!'
        }
      }} /> : undefined} label={company.companyName} size="x-small" color="brand" variant="soft" className="max-w-full! [&_.MuiChip-label]:truncate! font-medium!" />
                </div>}

            <Divider />

            <p className="pt-5 px-4 pt-3 pb-0.5 text-[11px] font-medium uppercase tracking-wide text-foreground-muted">Account</p>

            <MenuItem className="mx-1! rounded-lg! px-3! py-2.5!" onClick={() => {
      onClose();
      router.push(`/${companySlug}/profile`);
    }}>
                <ListItemIcon className="min-w-9!">
                    <TbUser className="size-5" />
                </ListItemIcon>
                <ListItemText primary="Profile" primaryTypographyProps={{
        className: 'text-sm! font-medium!'
      }} />
            </MenuItem>

            {isDarkModeEnabled && <MenuItem className="mx-1! rounded-lg! px-3! py-2.5!" onClick={handleToggleColorMode}>
                    <ListItemIcon className="min-w-9!">
                        <TbMoon className="size-5" />
                    </ListItemIcon>
                    <ListItemText primary={<span className="inline-flex items-center gap-1.5">
                                Dark mode
                                <Chip label="Beta" size="x-small" variant="soft" color="brand" className="font-medium!" />
                            </span>} primaryTypographyProps={{
        className: 'text-sm! font-medium!',
        component: 'div'
      }} />
                    <Switch size="small" edge="end" checked={colorMode === 'dark'} onClick={e => e.stopPropagation()} onChange={(_, checked) => setColorMode(checked ? 'dark' : 'light')} className="mr-0.5!" />
                </MenuItem>}

            {Number(user?.linkedCompaniesCount || 0) > 1 && <MenuItem className="mx-1! rounded-lg! px-3! py-2.5!" onClick={() => {
      onClose();
      window.location.href = '/api/auth/switch-company';
    }}>
                    <ListItemIcon className="min-w-9!">
                        <TbArrowsLeftRight className="size-5" />
                    </ListItemIcon>
                    <ListItemText primary="Switch Company" primaryTypographyProps={{
        className: 'text-sm! font-medium!'
      }} />
                </MenuItem>}

            <Divider className="my-2!" />

            <MenuItem className={clsx('mx-1! my-1! rounded-lg! px-3! py-2.5!', 'text-[var(--status-error)]!')} onClick={() => {
      onClose();
      handleLogout();
    }}>
                <ListItemIcon className="min-w-9! text-inherit!">
                    <TbLogout className="size-5" />
                </ListItemIcon>
                <ListItemText primary="Logout" primaryTypographyProps={{
        className: 'text-sm! font-medium! text-inherit!'
      }} />
            </MenuItem>
        </Menu>;
};